'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { PlusIcon } from '@insta-club/components/icons';
import { PageAccountsResponse } from '@insta-club/models';
import { BottomSheet } from '@insta-club/ui';
import { cn } from '@insta-club/utilities';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useAccountSwitcherSheetStore } from 'src/libs/state/stores/accountSwitcherSheet';
import useSWR from 'swr';
import AccountItem from './AccountItem';

function AccountSwitcherSheet() {
    const pathName = usePathname();
    const includedPaths = ['/dashboard', '/analysis', '/explore', '/academy', '/profile'];
    const isIncludedPaths = includedPaths.includes(pathName);

    const { data, isLoading } = useSWR<PageAccountsResponse>(
        isIncludedPaths ? ApiKeys.GET_PAGE_LIST : null,
        (url: string) => fetcher(url, 'dashboard', 'GET')
    );

    const accountSwitcherSheetOpen = useAccountSwitcherSheetStore((state) => state.isOpen);
    const accountSwitcherSheetClose = useAccountSwitcherSheetStore((state) => state.closeDrawer);

    if (!isIncludedPaths) return null;

    return (
        <>
            <BottomSheet
                title='لیست پیج‌های من'
                open={accountSwitcherSheetOpen}
                onClose={accountSwitcherSheetClose}
                contentClassName={'bg-[#FBFBFF]'}
            >
                <p className='mb-6 text-sm font-normal text-gray-500'>
                    با کلیک روی آیدی پیج می‌توانید پروفایل اکانت خود را بارگذاری کنید.
                </p>
                <div className='space-y-3'>
                    <div
                        className={cn({
                            'custom-scrollbar h-[200px] overflow-y-auto': data ? data?.data?.length > 2 : false
                        })}
                    >
                        <div className='space-y-4'>
                            {isLoading
                                ? Array.from({ length: 5 }, (_, index) => {
                                      return (
                                          <div
                                              key={index}
                                              className={cn(
                                                  'flex animate-pulse items-center justify-between space-x-3 rounded-2xl border border-transparent bg-gray-100 p-4'
                                              )}
                                          >
                                              <div className='flex items-center space-x-3'>
                                                  <div className='h-[41px] w-[41px] rounded-full bg-gray-200' />
                                                  <div className='flex flex-col space-y-3'>
                                                      <div className='h-3.5 w-24 rounded bg-gray-200' />
                                                      <div className='h-3 w-32 rounded bg-gray-200' />
                                                  </div>
                                              </div>
                                              <div className='flex items-center space-x-3'>
                                                  <div className='h-5 w-5 rounded bg-gray-200' />
                                                  <div className='h-5 w-5 rounded bg-gray-200' />
                                              </div>
                                          </div>
                                      );
                                  })
                                : data?.data.map((page) => {
                                      return <AccountItem key={page.id} data={page} />;
                                  })}
                        </div>
                    </div>

                    <Link href={'/profile/add-page/intro'} onClick={accountSwitcherSheetClose}>
                        <div className='rounded-2xlp-4 flex items-center space-x-3'>
                            <div className='bg-primary-500 flex h-10 w-10 items-center justify-center rounded-full'>
                                <PlusIcon className='text-white' />
                            </div>
                            <span className='text-sm font-semibold text-gray-800'>افزودن پیج جدید</span>
                        </div>
                    </Link>
                </div>
            </BottomSheet>
        </>
    );
}

export default AccountSwitcherSheet;

